// Import dependencies
import Player from '@vimeo/player';
import { initialiser } from '../../ramen-imports/utilitybelt';

class HeroVimeo {
  constructor(config) {
    const { el, settings } = config;

    this.videoId = el.dataset.videoId;
    this.player = new Player(el, {
      autoplay: true,
      controls: false,
      id: this.videoId,
      height: '100%',
      loop: true,
      muted: true,
      title: false,
      width: '100%',
    });

    this.settings = settings;
  }

  init() {
    this.bindEvents();
  }

  bindEvents = () => {
    this.player.on('loaded', () => {
      this.player.play();
    });
  };
}

export default (settings) => initialiser(settings, HeroVimeo);
